import { c } from '../../../utils/tailwind-merge';
import { Badge } from '../../atoms/Badge/Badge';
import { RichText } from '../RichText';
import { CertifiedPublisherProps } from './CertifiedPublisher.types';

export const CertifiedPublisher = ({
  text,
  microcopy,
  className = '',
}: CertifiedPublisherProps) => {
  return (
    <Badge
      text={text}
      iconName="BlueShieldCheckmark"
      iconPosition="after"
      tooltip={
        <RichText
          html={microcopy.description}
          className="text-gray-400 text-sm [&_p]:mb-0"
        />
      }
      className={c('shrink-0', className)}
      data-test="certified-publisher-badge"
    />
  );
};
